import "./HomeCareersSection.scss";

function CareersSection() {
  return (
    <div id="careers" className="careers-section">
      <div className="careers-section__title">careers</div>
      <div className="careers-section__content">
        <div className="careers-section__center-text">
          create a positive impact through earth observation
        </div>
        <a href="https://jobs.ashbyhq.com/hum-ai/" target="_blank" className="">
          <button className="careers-section__learn-more-button">
            see open roles
          </button>
        </a>
      </div>
    </div>
  );
}

export default CareersSection;
